import React from 'react';
import { Table, Badge, Button } from 'react-bootstrap';
import moment from 'moment';

export const BudgetHistory = ({ history, onClearHistory }) => {
    const getActionBadge = (action) => {
        const actionConfig = {
            created: {
                bg: 'success',
                icon: 'ri-add-circle-line',
                label: 'Created'
            },
            updated: {
                bg: 'primary',
                icon: 'ri-edit-line',
                label: 'Updated'
            },
            deleted: {
                bg: 'danger',
                icon: 'ri-delete-bin-line',
                label: 'Deleted'
            },
            expense_added: {
                bg: 'warning',
                icon: 'ri-money-dollar-circle-line',
                label: 'Expense Added'
            }
        };

        const config = actionConfig[action] || actionConfig.updated;
        return (
            <Badge bg={config.bg} className="d-flex align-items-center gap-1" style={{ width: 'fit-content' }}>
                <i className={config.icon}></i>
                <span>{config.label}</span>
            </Badge>
        );
    };

    const formatAmountChange = (change, action) => {
        if (action === 'created') {
            return <span className="text-primary">Budget: ${Math.abs(change).toLocaleString()}</span>;
        }
        
        if (change === null || change === undefined || change === 0) return '-';
        
        const isPositive = change > 0;
        const amount = Math.abs(change).toLocaleString();
        return (
            <span className={`text-${isPositive ? 'success' : 'danger'}`}>
                {isPositive ? '+' : '-'}${amount}
            </span>
        );
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Budget History</h6>
                {history && history.length > 0 && (
                    <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={onClearHistory}
                        className="d-flex align-items-center gap-1"
                    >
                        <i className="ri-delete-bin-line"></i>
                        Clear History
                    </Button>
                )}
            </div>
            <Table responsive hover className="table-striped">
                <thead>
                    <tr>
                        <th>Date & Time</th>
                        <th>Budget Name</th>
                        <th>Action</th>
                        <th>Amount Change</th>
                    </tr>
                </thead>
                <tbody>
                    {history.map((entry) => (
                        <tr key={entry.id}>
                            <td>
                                <div className="fw-medium">
                                    {moment(entry.timestamp).format('MMM DD, YYYY')}
                                </div>
                                <small className="text-muted">
                                    {moment(entry.timestamp).format('hh:mm A')}
                                </small>
                            </td>
                            <td>
                                <div className="fw-medium">{entry.budgetName}</div>
                                <small className="text-muted">{entry.budgetCategory}</small>
                            </td>
                            <td>{getActionBadge(entry.action)}</td>
                            <td className="fw-medium">
                                {formatAmountChange(entry.amountChange, entry.action)}
                            </td>
                        </tr>
                    ))}
                    {(!history || history.length === 0) && (
                        <tr>
                            <td colSpan="4" className="text-center py-4">
                                <i className="ri-history-line fs-24 text-muted d-block mb-2"></i>
                                <p className="text-muted mb-0">No history available</p>
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
}; 